/* eslint-disable eqeqeq */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import LoadingAnimation from "../../components/LoadingAnimation";
import { IoIosArrowBack } from "react-icons/io";
import { Link } from "react-router-dom";

function CampaignsGroupBy(props) {
  const [data, setData] = useState([]);
  const [toEditSubId, setToEditSubId] = useState(null);
  const [campaignData, setCampaignData] = useState([]);
  const [CampaignColumns, setCampaignColumns] = useState([
    {
      id: "1",
      title: "campaign_names",
      key: "campaign_names",
      visible: true,
      locked: true,
      category: "Recommended",
    },
    {
      id: "2",
      title: "group_name",
      key: "group_name",
      visible: true,
      locked: true,
      category: "Recommended",
    },
  ]);
  const [searchParams] = useSearchParams();
  const selectedSubId = searchParams.get("sub_channel_id");
  const [columns, setColumns] = useState([
    { id: 0, title: "Group Name", key: "group_name", visible: true },
    { id: 1, title: "Campaign Names", key: "campaign_names", visible: true },
    { id: 2, title: "Total Campaigns", key: "total_campaigns", visible: true },
    // {id:2 , title:"Campaign Ids", key:"campaign_ids", visible:true},
    { id: 3, title: "Edit", key: "edit", visible: true },
    { id: 4, title: "Delete", key: "delete", visible: true },
  ]);

  const [savedGroups, setSavedGroups] = useState([]);
  const [groupsVisible, setGroupsVisible] = useState(true);
  const [campaignsVisible, setCampaignsVisible] = useState(false);
  const [updateCounter, setUpdateCounter] = useState(false);
  const navigate = useNavigate(); // Add this inside your component

  const [random, setRandom] = useState(Math.random());
  useEffect(() => {
    if (selectedSubId && savedGroups.length > 0) {
      const matchedGroup = savedGroups.find(
        (sub) => sub.sub_channel_id === selectedSubId,
      );

      if (matchedGroup) {
        setGroupName(matchedGroup.group_name);
        setToEditSubId(matchedGroup.group_id);

        const finObj = matchedGroup.campaign_ids.map((id, index) => ({
          id: Number(id),
          campaign_name: matchedGroup.campaign_names[index],
        }));

        setSelectedRows(finObj);
        setGroupsVisible(false);
        setCampaignsVisible(true);
      }
    }
  }, [selectedSubId, savedGroups]);

  useEffect(() => {
    axios
      .post("https://api.confidanto.com/sub-channel/fetch-sub-channel-by-id", {
        email: localStorage.getItem("email"),
        customer_id: localStorage.getItem("customer_id"),
        sub_channel_id: selectedSubId,
      })
      .then((res) => {
        let objVal = Object.values(res.data)[0];
        let tempData = objVal.map((i) => {
          return {
            group_name: i.group_name,
            campaign_names: i.campaign_names,
            campaign_ids: i.campaign_ids,
            group_id: i.group_id,
            total_campaigns: i.number_of_campaigns,
          };
        });
        setSavedGroups(objVal);
        setData(tempData);
        console.log("GROUPS:", objVal, tempData, res);
      });

    if (localStorage.getItem("customer_id") == "7948821642") {
      let url = "https://api.confidanto.com/campaign-group/fetch-groups";
      let requestBody = {
        customer_id: "7948821642",
        email: localStorage.getItem("email"),

        ad_account_id: localStorage.getItem("ad_account_id"),
        platform: localStorage.getItem("platform"),
        project_id: localStorage.getItem("project_id"),
      };
      let dummyCols = [
        {
          id: "1",
          title: "Group name",
          key: "group_name",
          visible: true,
          locked: true,
          category: "Recommended",
          isLocked: true,
        },
        {
          id: "2",
          title: "campaign_names",
          key: "campaign_names" || "",
          visible: true,
          locked: true,
          category: "Recommended",
          isLocked: false,
        },
      ];

      axios.post(url, requestBody).then((res) => {
        console.log("Campaigns:", res.data);
        setCampaignData(res.data);
        setCampaignColumns(dummyCols);
      });
    } else {
      axios
        .post("https://api.confidanto.com/campaign-group/fetch-groups", {
          customer_id: localStorage.getItem("customer_id"),
          email: localStorage.getItem("email"),
          project_id: localStorage.getItem("project_id"),

          ad_account_id: localStorage.getItem("ad_account_id"),
          platform: localStorage.getItem("platform"),
        })
        .then((res) => {
          console.log("Campaigns:", res.data);
          setCampaignData(res.data);
        });
    }
    console.log(campaignData, savedGroups);
  }, [updateCounter, random]);

  const deleteCampaignsGroup = (val) => {
    let id = val["group_id"];
    let name = val["group_name"];

    let con = window.confirm(`Delete ${name} Group?`);

    if (con) {
      axios
        .post("https://api.confidanto.com/campaign-group/delete", {
          email: localStorage.getItem("email"),
          group_id: id,
        })
        .then((res) => {
          console.log("Group Deleted with id and name: ", id, name);
          setUpdateCounter(!updateCounter);
          setRandom(Math.random());
        });
    }
  };

  const fetchCampaignsForGroup = (val) => {
    let ids_arr = val["campaign_ids"];
    let names_arr = val["campaign_names"];

    setGroupName(val["group_name"]);
    setToEditSubId(val["group_id"]);
    let finObj = [];
    for (const iterator in ids_arr) {
      let obj = {
        id: Number(ids_arr[iterator]),
        campaign_name: names_arr[iterator],
      };

      finObj.push(obj);
    }

    console.log(finObj, toEditSubId);

    setSelectedRows(finObj);

    setGroupsVisible(false);
    setCampaignsVisible(true);
  };

  const cancelGroupEdit = () => {
    navigate("/google-ads/group");
  };

  const editSavedGroup = () => {
    const groupData = {
      group_id: toEditSubId,
      campaign_ids: selectedRows.map((row) => row.id),
      campaign_names: selectedRows.map((row) => row.campaign_name),
      number_of_campaigns: selectedRows.length,
      email: localStorage.getItem("email"), // or any other way to get the email
      customer_id: localStorage.getItem("customer_id"),
    };
    console.log("groupData", groupData);

    axios
      .post("https://api.confidanto.com/campaign-group/edit", groupData)
      .then((res) => {
        console.log("Updated: ", res);

        alert("Group Updated");
        setGroupsVisible(true);
        setCampaignsVisible(false);

        setUpdateCounter(!updateCounter);
        setRandom(Math.random());
      });
  };
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [tableVisible, setTableVisible] = useState(true);
  const [isVisibleGroupInput, setIsVisibleGroupInput] = useState(false);
  const [groupNames, setGroupNames] = useState([]);
  const [groupName, setGroupName] = useState("");
  const [isDialogOpenCreateGroup, setIsDialogOpenCreateGroup] = useState(false);

  const PercentColumns = [
    "impressions_percent_diff",
    "costs_percent_diff",
    "clicks_percent_diff",
    "conversion_percent_diff",
    "ctr_percent_diff",
    "cost_per_conv_percent_diff",
    "average_cpc_percent_diff",
  ];
  const fetchGroups = async () => {
    try {
      const response = await axios.post(
        "https://api.confidanto.com/campaign-group/fetch-groups",
        {
          email: localStorage.getItem("email"),
          customer_id: localStorage.getItem("customer_id"),
        },
      );

      if (response.data.groups) {
        const groupsData = response.data.groups;
        setSavedGroups(groupsData);

        // Extract group IDs
        const names = groupsData.map((group) => group.group_name);
        setGroupNames(names);
      }
    } catch (error) {
      console.error("Error fetching campaign groups:", error);
    }
  };

  const handleCheckboxChange = (id, campaign_name) => {
    const isSelected = selectedRows.some((row) => row.id === id);
    console.log(selectedRows);

    if (isSelected) {
      setSelectedRows(selectedRows.filter((row) => row.id !== id));
    } else {
      setSelectedRows([...selectedRows, { id, campaign_name }]);
    }
  };
  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      const allSelectedRows = data.map((item) => ({
        id: item.id,
        campaign_name: item.name,
      }));
      setSelectedRows(allSelectedRows);
    } else {
      setSelectedRows([]);
    }
  };
  return (
    <div className="mx-4">
      <Link to="/google-ads/group">
        <IoIosArrowBack className="space-x-2 h-8 w-8  shadow-lg hover:bg-slate-200 rounded-lg mt-1 mr-2" />
      </Link>
      <div>
        {campaignsVisible && (
          <div className="flex-grow overflow-auto mb-12">
            {selectedRows.length >= 2 && (
              <div className="p-2 w-full bg-[#4142dc] flex items-center">
                <p className="text-lg text-white font-normal p-2 my-4 pr-4 border-r-1 border-white">
                  {selectedRows.length} selected
                </p>
                <div className="flex justify-center items-center">
                  <input
                    type="text"
                    className="text-lg text-white bg-transparent border-b-1 border-white p-2 focus:outline-none"
                    placeholder="Group Name"
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                  />
                  <button
                    className="bg-white text-[#4142dc] text-lg  m-4 font-semibold px-4 py-1.5"
                    onClick={editSavedGroup}
                  >
                    Save
                  </button>
                  <button
                    className="bg-white text-[#4142dc] text-lg  m-4 font-semibold px-4 py-1.5"
                    onClick={cancelGroupEdit}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}

            <>
              {tableVisible && (
                <div className="flex-grow overflow-auto mb-12">
                  {campaignData.length > 0 ? (
                    <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-md font-roboto">
                      <thead className=" bg-[#2930a8] text-white">
                        <tr className=" normal-case text-sm leading-normal">
                          <th className="py-3 px-6 text-left font-medium"></th>
                          {CampaignColumns.filter((col) => col.visible).map(
                            (col) => (
                              <th
                                key={col.key}
                                className="py-3 px-6 text-left font-medium"
                              >
                                {col.title}
                              </th>
                            ),
                          )}
                        </tr>
                      </thead>
                      <tbody className="text-gray-600 text-sm font-light font-roboto">
                        {campaignData.map((item, index) => (
                          <tr
                            key={index}
                            className={`border-b   ${
                              selectedRows.some((row) => row.id === item.id)
                                ? "bg-blue-100 border-gray-300"
                                : "hover:bg-gray-100 border-gray-200"
                            }`}
                          >
                            <td className="py-3 px-6 text-left">
                              <input
                                type="checkbox"
                                checked={selectedRows.some(
                                  (row) => row.id === item.id,
                                )}
                                onChange={() =>
                                  handleCheckboxChange(item.id, item.name)
                                }
                              />
                            </td>

                            {CampaignColumns.filter((col) => col.visible).map(
                              (col) => (
                                <td
                                  key={col.key}
                                  className="py-3 px-6 text-left"
                                >
                                  {col.key !== "status" &&
                                    (Array.isArray(item[col.key])
                                      ? item[col.key].join(", ")
                                      : item[col.key])}
                                  {/* Render the status cell */}
                                  {PercentColumns.indexOf(col.key) != -1 ? (
                                    <span> %</span>
                                  ) : null}
                                  {col.key === "status" ? (
                                    <div className="flex items-center">
                                      {item.status === "ENABLED" && (
                                        <div className="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
                                      )}
                                      {item.status === "PAUSED" && (
                                        <div className="w-3 h-3 bg-gray-500 rounded-full mr-2"></div>
                                      )}
                                      {item.status === "REMOVED" && (
                                        <div className="w-3 h-3 bg-red-500 rounded-full mr-2"></div>
                                      )}
                                    </div>
                                  ) : null}
                                </td>
                              ),
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="flex justify-center items-center h-40 mt-8">
                      <LoadingAnimation />
                    </div>
                  )}
                </div>
              )}
            </>
          </div>
        )}
      </div>
    </div>
  );
}

export default CampaignsGroupBy;
